var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeCrossed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1740_8287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.90869 4.09949L7.62648 5.81728L7.63466 5.7273C7.63466 4.82477 6.9012 4.09131 5.99867 4.09131L5.90869 4.09949Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99879 3.00065C7.5039 3.00065 8.72545 4.2222 8.72545 5.72731C8.72545 6.07905 8.65457 6.41442 8.53187 6.72253L10.127 8.31762C10.9504 7.6305 11.5994 6.74162 12.0002 5.72731C11.054 3.33332 8.72819 1.63733 5.99882 1.63733C5.23535 1.63733 4.50462 1.77365 3.82568 2.01905L5.0036 3.19423C5.31168 3.07427 5.64705 3.00065 5.99879 3.00065Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.545322 1.51463L1.78868 2.75799L2.03681 3.00612C1.13701 3.7096 0.425358 4.64485 0 5.72731C0.943431 8.1213 3.27198 9.81729 5.99865 9.81729C6.84392 9.81729 7.651 9.65369 8.38993 9.35648L8.6217 9.58825L10.2114 11.1806L10.9066 10.488L1.24062 0.819336L0.545322 1.51463ZM3.56102 4.52759L4.40355 5.37013C4.37901 5.48738 4.36265 5.60461 4.36265 5.72731C4.36265 6.62984 5.09612 7.3633 5.99865 7.3633C6.12135 7.3633 6.2386 7.34694 6.35312 7.3224L7.19565 8.16494C6.833 8.3449 6.42947 8.45397 5.99865 8.45397C4.49353 8.45397 3.27198 7.23242 3.27198 5.72731C3.27198 5.29651 3.38106 4.89296 3.56102 4.52759Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1740_8287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCrossed);
export default __webpack_public_path__ + "static/media/eyeCrossed.06a813ff1177b24a9ce222a63a1d6c8a.svg";
export { ForwardRef as ReactComponent };